import(/* webpackMode: "eager" */ "/vercel/path0/apps/prono-rtbf/app/rules/page.tsx");
